<template>
  <div class="footer">
    <div class="footer_in">
      地址：武汉市武昌区东湖路169号 <span>邮编：430071</span>
    </div>
    <div class="footer_in">
      <i class="footerIcon"></i>
      <div>
        鄂公网安备 42010602004397号 武汉大学中南医院 版权所有鄂ICP备14010630号-1
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      activeindex: 0,
      searchInput: "",
      list: [
        { menu: "首页", url: "index.html" },
        { menu: "中心介绍", url: "index.html" },
        { menu: "通知公告", url: "Notice.html" },
        { menu: "办事指南", url: "guide.html" },
        { menu: "政策法规", url: "policyStatute.html" },
        { menu: "GCP专业科室", url: "GCP.html" },
        { menu: "医学伦理委员会", url: "committee.html" },
        { menu: "技术转移机构", url: "committee.html" },
        { menu: "下载中心", url: "downloadCenter.html" },
        { menu: "关于我们", url: "aboutUs.html" },
      ],
    };
  },
};
</script>

<style scoped>
.footer {
  background-color: #424c56;
  height: 75px;
  padding-top: 13px;
  
}
.footerIcon {
  width: 18px;
  height: 20px;
  background: url(../../static/images/common/footerIcon.png) no-repeat;
  background-size: cover;
  margin-right: 5px;
}
.footer_in {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #fff;
  margin-bottom: 7px;
}
.footer_in span {
  margin-left: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue